<div (click)="navigateToTopicDetails()" class="SLV2-tpcsummry-crdbox {{selfLearnService?.getSubjectName()?.replace(' ','') | lowercase}}">
    <div class="tpcsummry-icon-box">
        <span class="tpcsummry-lst-cunt"></span>
        <span class="SLV2-tpcsummry-subjct-name">{{selfLearnService?.getSubjectName()}}</span>
        <img src="selflearnv2-ui/assets/img/self-learn-v2/cards-icon-img.png" />
    </div>
    <div class="tpcsummry-cntarea">
        <div class="tpcsummry-prgrss-area">
            <div class="tpcsummry-prgrss"><span [style.width]="((completedCount) / (flashcardData?.publishedFlashcardCount))*100 +'%'"></span></div>
            <div class="tpcsummry-card-cunttext"><span>{{completedCount}}/</span>{{flashcardData?.publishedFlashcardCount}} cards</div>
        </div>
        <h4 class="tpcsummry-title">{{topicName}}</h4>
    </div>
</div>
